<template>
  <div class="d-flex">
    <b-form-input
        v-model="searchString"
        class="w-75"
        placeholder="user id | username | бот-ключ"
        @keydown.enter="search"
    />

    <b-button
        class="w-25"
        size="sm"
        variant="success"
        @click="search"
    >
      Искать
    </b-button>
  </div>
</template>

<script>
import {ApiService} from "@/api";

export default {
  name: 'AppSearch',
  data() {
    return {
      searchString: ''
    }
  },
  methods: {
    search() {
      const trimmedSearchString = this.searchString.trim()

      if (!trimmedSearchString) {
        this.$emit('hideResult')
        return
      }

      ApiService.search(trimmedSearchString)
          .then(res => {
            this.$emit('searchResult', res)
          })
          .catch(err => console.error(err))
    }
  }
}
</script>
